import produce from 'immer';
import * as actions from './actions';

export const initialState = {
  linked: { data: null, loading: false, error: null },
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
    case actions.LINK_GUARDIAN_CONTACT_TO_ACCOUNT_REQUEST:
      draft.linked.loading = true;
      break;
    case actions.LINK_GUARDIAN_CONTACT_TO_ACCOUNT_SUCCESS:
      draft.linked.loading = false;
      draft.linked.data = true;
      break;
    case actions.LINK_GUARDIAN_CONTACT_TO_ACCOUNT_FAILURE:
      draft.linked.loading = false;
      draft.linked.error = action.payload.error;
      break;
    case actions.INIT_LINKED:
      draft.linked = { data: null, loading: false, error: null };
      break;
    default:
  }
});

export default reducer;
